import { z } from 'zod';
import { CurrencyCode } from '../schemas/site.js';

export const MaterialPriceRow = z.object({
  id: z.number().int().positive(),
  material_id: z.number().int().positive(),
  currency: CurrencyCode,
  price: z.number().positive(),
  valid_from: z.string().datetime(),
  valid_to: z.string().datetime().nullable(),
});
export type MaterialPrice = z.infer<typeof MaterialPriceRow>;

// Base PLN prices per m²: matt-vinyl=49, eco-paper=39, satin=79, structural-canvas=89, premium-textile=129
// EUR ≈ PLN / 4.25
// CZK ≈ PLN * 5.6
export const MATERIALS_PRICES: readonly MaterialPrice[] = [
  // matt-vinyl (material_id: 1) — PLN 49, EUR 11.53, CZK 274.40
  { id: 1,  material_id: 1, currency: 'PLN', price: 49.00,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 2,  material_id: 1, currency: 'EUR', price: 11.53,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 3,  material_id: 1, currency: 'CZK', price: 274.40,  valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  // eco-paper (material_id: 2) — PLN 39, EUR 9.18, CZK 218.40
  { id: 4,  material_id: 2, currency: 'PLN', price: 39.00,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 5,  material_id: 2, currency: 'EUR', price: 9.18,    valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 6,  material_id: 2, currency: 'CZK', price: 218.40,  valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  // satin (material_id: 3) — PLN 79, EUR 18.59, CZK 442.40
  { id: 7,  material_id: 3, currency: 'PLN', price: 79.00,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 8,  material_id: 3, currency: 'EUR', price: 18.59,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 9,  material_id: 3, currency: 'CZK', price: 442.40,  valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  // structural-canvas (material_id: 4) — PLN 89, EUR 20.94, CZK 498.40
  { id: 10, material_id: 4, currency: 'PLN', price: 89.00,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 11, material_id: 4, currency: 'EUR', price: 20.94,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 12, material_id: 4, currency: 'CZK', price: 498.40,  valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  // premium-textile (material_id: 5) — PLN 129, EUR 30.35, CZK 722.40
  { id: 13, material_id: 5, currency: 'PLN', price: 129.00,  valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 14, material_id: 5, currency: 'EUR', price: 30.35,   valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
  { id: 15, material_id: 5, currency: 'CZK', price: 722.40,  valid_from: '2026-01-01T00:00:00.000Z', valid_to: null },
] as const;

MATERIALS_PRICES.forEach((p) => MaterialPriceRow.parse(p));
